import React from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'

const PlayPauseIcon = ({ isPlaying, className = '' }) => {
  const location = useLocation()
  const isHalloween = !!location.pathname.includes('/halloween')
  if (isPlaying) {
    // Pause icon
    return (
      <svg width='44' height='44' viewBox='0 0 44 44' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
        <rect x='2' y='2' width='40' height='40' rx='8' fill='#FB6284' />
        <rect x='1.375' y='1.375' width='41.25' height='41.25' rx='8.625' stroke='white' strokeWidth='1.25' />
        <rect x='14' y='12' width='4' height='20' rx='2' fill='white' />
        <rect x='26' y='12' width='4' height='20' rx='2' fill='white' />
      </svg>
    )
  }

  // Play icon
  return (
    <svg width='44' height='44' viewBox='0 0 44 44' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
      <rect x='2' y='2' width='40' height='40' rx='8' fill={`${isHalloween ? 'rgba(237, 113, 43, 1)' : '#FB6284'}`} />
      <rect x='1.375' y='1.375' width='41.25' height='41.25' rx='8.625' stroke='white' strokeWidth='1.25' />
      <path d='M18 12L30 22L18 32V12Z' fill='white' />
    </svg>
  )
}

PlayPauseIcon.propTypes = {
  isPlaying: PropTypes.bool.isRequired,
  className: PropTypes.string,
}

export default PlayPauseIcon
